﻿package com.mgacreative.hotelru.domain.repository

import com.mgacreative.hotelru.domain.model.BlacklistedGuest
import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.postgrest.postgrest
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext
import kotlinx.datetime.Clock

interface BlacklistRepository {
    suspend fun getBlacklistedGuests(): List<BlacklistedGuest>
    suspend fun addBlacklistedGuest(guest: BlacklistedGuest): Boolean
    suspend fun deleteBlacklistedGuest(id: String): Boolean
    suspend fun checkIsBlacklisted(fullName: String, identityNo: String): BlacklistedGuest?
}

class BlacklistRepositoryImpl(
    private val supabase: SupabaseClient
) : BlacklistRepository {

    private val inMemoryBlacklist = mutableListOf(
        BlacklistedGuest(
            id = "bl-1",
            fullName = "Ahmet Yılmaz",
            identityNo = "12345678901",
            reason = "Hasarlı oda teslimi ve kaçak çıkış (Ödeme yapılmadı)",
            createdAt = "15.01.2026"
        ),
        BlacklistedGuest(
            id = "bl-2",
            fullName = "John Doe",
            identityNo = "A12345678",
            reason = "Tesis içinde huzursuzluk çıkarma ve uyarıları dikkate almama",
            createdAt = "10.02.2026"
        )
    )

    override suspend fun getBlacklistedGuests(): List<BlacklistedGuest> = withContext(Dispatchers.Default) {
        try {
            val remote = supabase.postgrest["blacklisted_guests"].select().decodeList<BlacklistedGuest>()
            if (remote.isNotEmpty()) {
                return@withContext remote
            }
        } catch (e: Exception) {
            // Supabase fallback to inMemory list
        }
        return@withContext inMemoryBlacklist.toList()
    }

    override suspend fun addBlacklistedGuest(guest: BlacklistedGuest): Boolean = withContext(Dispatchers.Default) {
        val newGuest = if (guest.id.isBlank()) {
            guest.copy(id = "bl-${Clock.System.now().toEpochMilliseconds()}")
        } else guest
        inMemoryBlacklist.add(0, newGuest)
        try {
            supabase.postgrest["blacklisted_guests"].insert(newGuest)
        } catch (e: Exception) {
            // Ignore network errors in offline mode
        }
        return@withContext true
    }

    override suspend fun deleteBlacklistedGuest(id: String): Boolean = withContext(Dispatchers.Default) {
        inMemoryBlacklist.removeAll { it.id == id }
        try {
            supabase.postgrest["blacklisted_guests"].delete {
                filter { eq("id", id) }
            }
        } catch (e: Exception) {
            // Ignore network errors in offline mode
        }
        return@withContext true
    }

    override suspend fun checkIsBlacklisted(fullName: String, identityNo: String): BlacklistedGuest? = withContext(Dispatchers.Default) {
        val allGuests = getBlacklistedGuests()
        return@withContext allGuests.firstOrNull { guest ->
            val matchIdentity = identityNo.isNotBlank() && guest.identityNo.isNotBlank() && 
                    guest.identityNo.trim() == identityNo.trim()
            val matchName = fullName.isNotBlank() && guest.fullName.isNotBlank() && 
                    guest.fullName.trim().equals(fullName.trim(), ignoreCase = true)
            matchIdentity || matchName
        }
    }
}

